import React, { useEffect } from "react";
import { useAuthContext } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import getLink, { LINK_TYPE } from "@/lib/links";

const TokenLogin = () => {
  const { tokenLogin } = useAuthContext();
  const navigate = useNavigate();

  const login = async (token: string) => {
    await tokenLogin(token);
    navigate(getLink(LINK_TYPE.HOME));
  };
  useEffect(() => {
    if (window.location.href && window.location.href.includes("login-token")) {
      const params = new URL(window.location.href).searchParams;
      const token = params.get("token");

      if (token) {
        login(token);
      }
    }
  }, []);

  return <div>TokenLogin</div>;
};

export default TokenLogin;
